module.exports = __webpack_public_path__ + "img/02.ee9d5afe.jpg";